export default __webpack_public_path__ + "static/media/digi-logo.8b6a7d68.png";